import { Component, Transform } from '@inter-ikea-core/core';

export default class AnimationComponent implements Component {
  static id = 2040;
  typeId = AnimationComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;
  from: Transform;
  to: Transform;
  startTime: number;
  endTime: number;
  duration: number;
  isAnimating: boolean;

  constructor(from: Transform, to: Transform, duration: number = 1000) {
    this.from = from;
    this.to = to;
    this.startTime = Date.now();
    this.duration = duration;
    this.endTime = this.startTime + duration;
    this.isAnimating = true;
  }

  eq() {
    return false;
  }
}
